<template>
  <header class="cf-header">
    <div class="cf-header-logo">
      <template v-if="merchant.options.logoUrl">
        <span
          class="cf-header-logo__image"
          :style="{ 'background-image': `url(${merchant.options.logoUrl})` }"
        />

        <span class="ada-text">{{ merchant.name }}</span>
      </template>

      <h1
        v-else
        class="cf-header-logo__text"
      >
        {{ merchant.name }}
      </h1>
    </div>
  </header>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'AppHeader',

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['currentUser'])
    }
  };
</script>
